import React, { Suspense, lazy } from 'react'

import { ManagedApp } from '@oceanjs/core';
import { Switch, Route } from 'react-router-dom';

import { Layout } from './components/Layout';
import { languageSettings } from './i18n';
import { Routes } from './Routes';
import { Home } from './views/Home';
import { PermissionRoute } from './components/Common/PermissionComponent';
import { Permissions } from './Permissions';
import { SuspenseLoading } from './components/Common/SuspenseLoading';
import { ErrorContainer, ErrorPage } from './views/Misc';
import { Accessiblity, GdprPage, Helpdesk, Imprint } from './views/general';
import { NetworkProvider, AppUserProvider } from './components';

const ParameterMgmt = lazy(() => import('./views/Parameter').then(module => ({ default: module['ParameterMgmt'] })));
const ComponentMgmt = lazy(() => import('./views/Component').then(module => ({ default: module['ComponentMgmt'] })));
const Uploads = lazy(() => import('./views/Upload').then(module => ({ default: module['Uploads'] })));


export const ReactApp: React.FC = () => {
  return (
    <ManagedApp
      languageSettings={languageSettings}
      environment={process.env}
      userProvider={AppUserProvider}
    >
      <ErrorContainer component={ErrorPage}>  
        <Layout>
          <NetworkProvider>
            <Suspense fallback={<SuspenseLoading />}>
              <Switch>
                <Route exact path={Routes.Home} component={Home} />
                <Route exact path={Routes.Imprint} component={Imprint} />
                <Route exact path={Routes.Accessibility} component={Accessiblity} />
                <Route exact path={Routes.Gdpr} component={GdprPage} />
                <Route exact path={Routes.Helpdesk} component={Helpdesk} />
                <Route path={Routes.ParameterMgmt} component={ParameterMgmt} />
                <Route path={Routes.ComponentMgmt} component={ComponentMgmt} />
                <PermissionRoute permission={[Permissions.FileUpload]}
                  exact path={Routes.Uploads} component={Uploads} />
                <Route path={Routes.Home} component={Home} />
              </Switch>
            </Suspense>
          </NetworkProvider>
        </Layout>
      </ErrorContainer>
    </ManagedApp>
  );
}
